export interface RadioOption {
  label: string;
  value: 'linked' | 'all';
}

export const RADIO_OPTIONS: RadioOption[] = [
  { label: 'Linked', value: 'linked' },
  { label: 'All', value: 'all' },
];

export const EMPTY_TEXT: Record<'linked' | 'all', string> = {
  linked: 'No goals linked to this critical element yet.',
  all: 'No goals available for the selected entering class year.',
};

export interface SortRule {
  id: string;
  desc: boolean;
}

export const INITIAL_SORTING: SortRule[] = [{ id: 'category', desc: false }];
